<template>
    <div class="col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
            <h2 class="h h--2">Faktury</h2>
            <p>Zobacz zarejestrowane przez siebie dowody zakupu, lub dodaj następne i zwiększ swoje szanse na wygraną.</p>
            <p><router-link :to="{name: 'Invoices'}" class="box__link">&raquo; Historia faktur</router-link></p>
            <router-link :to="{name: 'InvoicesAdd'}" class="button button__bottom">
                Dodaj dowód zakupu &raquo;
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InvoicesWidget',
        props: {
            color: {
                default: 'box--green'
            }
        },
        data () {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/invoices/InvoicesWidget.vue